var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schema",class:{'edit':_vm.schema.edit},on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.$emit('item-clicked', _vm.schema)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }